export default __webpack_public_path__ + "static/media/trash.f74491bc.svg";